import {Input} from "@mecatran-components/input";


export class StopListButton extends Input{
    constructor(inputOptions){
        var defaultOptions = {
            src: './assets/list.svg',
            classList : ['list'],
            style : { 'vertical-align': 'middle'} 
        }
        var inputOptions = inputOptions || defaultOptions;
        super(inputOptions);
    }
    /* ======================================= */
    /* Private                                 */
    /* ======================================= */
    onClickButton(event){
        this.emitCustomEvent('stopListEvent');
    }

    /* ======================================= */
    /* Overload                                */
    /* ======================================= */
    defineEventListeners(eventManager){
        eventManager.on('click',()=>true,this.onClickButton.bind(this),false);
    }
}
